<template>
  <q-chips-input
    :value="ipList"
    @clear="handleClear"
    @input="handleInput"
  >
  </q-chips-input>
</template>
<script>
export default {
  name: 'IpAddressChips',
  props: {
    value: {
      type: [String, Array],
      default: () => []
    },
    column: {
      type: Object,
      required: true
    },
    modelId: {
      type: [Number, String],
      default: () => null
    }
  },
  computed: {
    ipList () {
      if (Array.isArray(this.value)) {
        return this.value.reduce((arr, row) => {
          if (typeof row === 'object' && !!row.ip) {
            arr.push(row.ip)
            return arr
          }
          if (typeof row === 'string') {
            arr.push(row)
          }
          return arr
        }, [])
      }
      return this.value ? [this.value] : []
    },
    ipListObjects () {
      return this.ipList.map(ip => this.createIpObject(ip))
    }
  },
  methods: {
    handleClear (e) {
      // console.log(`Clear: ${e}`)
      this.$emit('change', [])
    },
    handleInput (e) {
      // console.log(`Input: ${e}`)
      this.$emit('change', e.map(ip => this.createIpObject(ip)))
    },
    createIpObject (ip) {
      let id = null
      if (this.value && Array.isArray(this.value)) {
        const record = this.value.find(r => r.ip === ip)
        if (record) {
          id = parseInt(record.id)
        }
      }
      return {
        id: isNaN(id) ? '' : id,
        ip: ip,
        employeeId: this.modelId ? this.modelId : null
      }
    }
  }
}
</script>
